import { jsx as _jsx } from "react/jsx-runtime";
import Rive from "@rive-app/react-canvas";
import React from "react";
import { cn } from "../cn";
export const SpinnerContext = React.createContext({
    spinnerUrl: "",
});
export function PrimarySpinner({ className }) {
    const spinnerContext = React.useContext(SpinnerContext);
    if (!spinnerContext.spinnerUrl) {
        throw new Error("spinnerUrl must be set before PrimarySpinner can be used");
    }
    return (_jsx(Rive, { src: spinnerContext.spinnerUrl, className: cn(className, "size-16 dark:hue-rotate-180 dark:invert") }));
}
export function PrimaryFullScreenSpinner() {
    return (_jsx("div", { className: "grid size-full place-content-center opacity-10", children: _jsx(PrimarySpinner, {}) }));
}
